import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
// import {MatMenuModule} from '@angular/material/menu';
import { Router } from '@angular/router'; 


@Component({
  selector: 'app-month-menu',
  templateUrl: './month-menu.component.html',
  styleUrls: ['./month-menu.component.css']
})
export class MonthMenuComponent implements OnInit {

  @Input() monthMenuData!: any;
  @Output() jumpTo: EventEmitter<any> = new EventEmitter();


  constructor(private router: Router) { }

  ngOnInit(): void {
  }


  gotoPage(monthIdNumber: string){
    // this.router.navigate(['2021', '7']); //parameter based url
    // this.router.navigateByUrl('/2021/8') //normal url
    this.jumpTo.emit({'monthId': monthIdNumber});
    // console.log('goto monthIdNumber', monthIdNumber)

  }

}

